;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import { AnimatePresence, m } from 'framer-motion';
import PropTypes from 'prop-types';

import CardNoResults from 'components/cards/CardNoResults';
import CardRecipeGrid from 'components/cards/CardRecipeGrid';
import ButtonCTA from 'components/ui/ButtonCTA';

import styles from './RecipesList.module.scss';

const RecipesList = ({
    recipes,
    activeFilters,
    recipesConfig,
    setLimit,
    limit,
    limitBase,
    increment,
}) => {
    const isNoResults = recipes.length === 0;

    const visibleLimit = limitBase + limit;

    const visibleItems =
        recipes.length <= visibleLimit
            ? recipes
            : recipes.slice(0, visibleLimit);

    const handleLoadMore = () => {
        setLimit(limit + increment);
    };

    return (
        <section className={styles.root}>
            <AnimatePresence>
                <m.div
                    className={styles.transition}
                    key={activeFilters}
                    animate={{ opacity: 1, position: 'relative' }}
                    exit={{ opacity: 0, position: 'absolute' }}
                    transition={{ duration: 0.4 }}
                >
                    <ul
                        className={cx(styles.inner, {
                            [styles.truncated]: recipes.length > limit,
                        })}
                    >
                        {visibleItems.map((recipe, i) => {
                            if (!recipe.slug) {
                                // These are an absolute must
                                return null;
                            }

                            return (
                                <li className={styles.listItem} key={i}>
                                    <CardRecipeGrid
                                        {...recipe}
                                        id={recipe.sys.id}
                                        images={recipe.imagesCollection.items}
                                        recipesConfig={recipesConfig}
                                    />
                                </li>
                            );
                        })}
                        {isNoResults && (
                            <li
                                className={cx(
                                    styles.listItem,
                                    styles.noResults
                                )}
                            >
                                <CardNoResults />
                            </li>
                        )}
                    </ul>
                    {recipes.length > visibleLimit && (
                        <div className={styles.loadButton}>
                            <span className={styles.buttonBg}>
                                <ButtonCTA
                                    text="Load More"
                                    style="filled-blue-ocean"
                                    onClick={handleLoadMore}
                                />
                            </span>
                        </div>
                    )}
                </m.div>
            </AnimatePresence>
        </section>
    );
};

RecipesList.propTypes = {
    activeFilters: PropTypes.array,
    limit: PropTypes.number,
    recipesConfig: PropTypes.object.isRequired,
    recipes: PropTypes.array,
    setLimit: PropTypes.func,
    limitBase: PropTypes.number,
    increment: PropTypes.number,
};

export default RecipesList;
